import { Component } from '@angular/core';
import { nav_path } from 'src/app/app-routing.module';
import { RoutingService } from '../../../services/routing.service';

@Component({
  selector: 'anon-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {
  nav_path = nav_path;
  constructor(public routingService: RoutingService) {}
}
